module.exports = __webpack_public_path__ + "static/media/elixir-gifts.0dff0b2f.pdf";